import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import { PageHeader, Spacer } from '../MasterCss';


const ModalBox = styled.div`
  background-image: linear-gradient(#21b2d3, #7abefd);
  position: fixed;
  width: 80vw;
  max-width: 400px;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  border-radius: 1em;
  border: 2px solid #08345C;
  filter: drop-shadow(4px 4px 4px #08345C);
  padding: 2rem;
  text-align: center;
`;

const LanguageOption = styled.button`
  /* Default: orange (same as standard button) */
  background: #ff8a00;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.25),
              inset -10px -10px 4px #ffad4c,
              inset 10px 10px 4px #cc6e00;
  border-radius: 1.5vh;
  width: auto;
  min-height: 4vh;
  min-width: 18vw;
  font-family: Bungee;
  font-style: normal;
  font-weight: normal;
  font-size: 2.8vh;
  line-height: 5vh;
  padding: 1.6vh;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  border-style: none;
  z-index: 5;
  transition: all 0.2s ease;
  margin: 4px 0;
  width: 80%;

  /* Hover & Active: turn purple (matches primary button) */
  &:hover,
  &:active {
    background: #a10094;
    box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.25),
                inset -10px -10px 4px #c202b2,
                inset 10px 10px 4px #8a0072;
    transform: scale(1.02);
  }

  /* Responsive: smaller screens */
  @media (max-width: 480px) {
    min-height: 6vh;
    font-size: 2.1vh;
    line-height: 3vh;
    min-width: 30vw;
    padding: 1vh;
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 85%;
    font-size: 2.4vh;
    padding: 1.2vh;
  }
`;
const LanguageModal = ({ handleClose }) => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose(); // close modal after selection
  };

  return (
    <ModalBox>
      <PageHeader>{t('languageModal.title')}</PageHeader>
       <Spacer />
      <LanguageOption onClick={() => changeLanguage('en')}>
        English
      </LanguageOption>
      <LanguageOption onClick={() => changeLanguage('es')}>
        Español
      </LanguageOption>
      <Spacer />
      <Button primary handleClick={handleClose} label={t('close')} />
    </ModalBox>
  );
};

export default LanguageModal;